export default __webpack_public_path__ + "static/media/banner.a29c3515.png";